import { Component, inject, OnInit } from '@angular/core';
import { AppdataService } from '../../service/appdata.service';
import { Router } from '@angular/router';
import { UserdataService } from '../../service/userdata.service';

@Component({
    selector: 'app-home-header',
    standalone: false,

    templateUrl: './home-header.component.html',
    styleUrl: './home-header.component.scss'
})
export class HomeHeaderComponent implements OnInit{
    // Injections
    protected userS = inject(UserdataService);
    protected appData = inject(AppdataService);
    protected router = inject(Router);

    showHeaderBackButton: boolean = false;

    public ngOnInit(): void {
        this.appData.showHeaderBackButton.subscribe(data => {
            this.showHeaderBackButton = data;
        });

    }

    gotoFaq() {
        window.open('/faq', '_blank');
    }

    goBackHome() {
        // Get role of user
        const role: string[] = this.userS.getUserDataByKey('role')!;

        if (role.includes('USER')) {
            this.router.navigate(['home', 'user']);

            return;
        }

        if (role.includes('ST_COACH')) {
            this.router.navigate(['home', 'mentor']);

            return;
        }
    }

    goOnePageBack() {
        this.appData.showHeaderBackButton.next(false);

        if (
            window.location.pathname.indexOf('/home/account') !== -1 ||
            window.location.pathname.indexOf('/home/user/account') !== -1
        ) {
            this.goBackHome()

            return;
        }

        window.history.back();
    }
}
